export default __webpack_public_path__ + "static/media/home-track-mobile-intersect.d55c7472.svg";